import React, { useContext } from 'react';
import type IdleTimer from 'react-idle-timer';

export const IdleTimerContext = React.createContext<React.RefObject<IdleTimer>>({
  current: null,
});

export const useIdleTimerContext = () => useContext(IdleTimerContext);
